export const BASE_URL = process.env.REACT_APP_API_KEY;
export const API_URL = BASE_URL + "api/";
export const PAD_API_MEDIA_URL = BASE_URL + "storage/pics/";
export const PAD_API_FILES_URL = BASE_URL + "storage/files/";


export const REACT_APP_API_KEY_MINDSCSAN1 = process.env.REACT_APP_API_KEY_MINDSCSAN;
export const REACT_APP_API_KEY_PAD_DASH1 = process.env.REACT_APP_API_KEY_PAD_DASH;
